// extracted by mini-css-extract-plugin
export default {"formContainer":"Formulario_formContainer__yT+uv","boxForm":"Formulario_boxForm__E9XWo"};